import { SET_SERVICE_TYPE_RADIO_VALUE } from 'actions';
import { ServiceType } from 'typings';

export function setServiceTypeRadioValue(serviceTypeRadioValue: ServiceType) {
  return { serviceTypeRadioValue, type: SET_SERVICE_TYPE_RADIO_VALUE };
}
